<template>
    <div class="content-box">
        <Title/>

        <Echarts/>
    </div>
</template>

<script>
export default {
    name: "industry",
    data() {
        return {
            params: {
                dataNav: [
                    {
                        name: "交易规模",
                        data: "shares",
                        unit: "亿元"
                    },
                    {
                        name: "用户规模",
                        data: "a100",
                        unit: "亿人"
                    },
                    {
                        name: "企业规模",
                        data: "a106",
                        unit: "万家"
                    },
                    {
                        name: "规模",
                        data: "a110",
                        unit: ""
                    },
                ],
                name: '私域电商'
            }
        }
    },
    created() {
        this.$store.dispatch('getIndustry', this.params)
    }
}
</script>